import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const FlexRow = styled(Common.FlexRow)``;

export const Bold = styled(Common.Bold)``;

export const LocalizationProvider = styled(Common.LocalizationProvider)``;

export const DateRangePicker = styled(Common.DateRangePicker)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const FilterButton = styled(Common.Button)`
	color: ${Theme.black} !important;
`;

export const Search = styled(Common.Search)``;

export const Popover = styled(Common.Popover)``;

export const PopoverBody = styled(Common.PopoverBody)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const PopoverTitle = styled(Common.PopoverTitle)``;

export const CircularProgress = styled(Common.CircularProgress)``;
